module.exports = __webpack_public_path__ + "static/media/va.8dcfa937.svg";